import React, { Component } from "react";
import styled from "styled-components";
import { themeColors } from "../../../../react/sharedStyles";
import { AiIcon } from "../../../SlideAi/SlideAiIcon";
import anime from "animejs";
import { $ } from "js/vendor";
import PresentationEditorController, { PanelType } from "../../../PresentationEditor/PresentationEditorController";

const Container = styled.div`
    background: ${themeColors.aiColor};
    color: white;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: bold;
    height: 40px;
    z-index: 10000;

    a {
        padding: 0px 5px;
        text-decoration: underline;
        cursor: pointer;
    }
`;

export class SlideAiBanner extends Component {
    constructor(props) {
        super(props);

        this.ref = React.createRef();
    }

    handleAccept = () => {
        let el = this.ref.current;
        let startBounds = el.getBoundingClientRect();

        let parentEl = el.parentElement;

        let $ideasPanel = $("#ideas-panel");
        let targetBounds = $ideasPanel[0].getBoundingClientRect();

        let $highlight = $ideasPanel.addEl($.div("slidebanner-highlight").css({
            background: themeColors.aiColor,
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            position: "absolute",
            // top: (targetBounds.top + (targetBounds.height / 2) - 20) + "px",
            // left: (targetBounds.left + (targetBounds.width / 2) - 20) + "px",
            zIndex: -1,
            transform: "translate(0px, -10px) scale(.1)"
        }));

        // Hide text node
        el.querySelector("#text").style.display = "none";

        let timeline = anime.timeline({
            easing: "easeOutQuad"
        });
        timeline.add({
            targets: parentEl,
            width: 40,
            left: startBounds.left + (startBounds.width / 2) - 20,
            duration: 300,
        }, 0);
        timeline.add({
            targets: parentEl,
            left: targetBounds.left, // + (targetBounds.width / 2) - 20,
            top: targetBounds.top - 70, // + (targetBounds.height / 2) - 20,
            scale: [1, .5],
            duration: 500,
        }, 300);
        timeline.add({
            targets: $highlight[0],
            scale: 6,
            opacity: [1, 0],
            duration: 600,
        }, 700);

        timeline.finished.then(() => {
            timeline.seek(0);
            el.querySelector("#text").style.display = "block";
            $(".slidebanner-highlight").remove();
        });

        timeline.play();
    }

    showVariations = () => {
        PresentationEditorController.showBottomPanel(PanelType.SLIDE_AI);
    }

    render() {
        return (
            <Container ref={this.ref}><AiIcon />
                <div id="text">This slide was generated with AI. You can either <a onClick={this.handleAccept}>keep it as is</a> or <a onClick={this.showVariations}>view more variations here</a>.</div>
            </Container>
        );
    }
}

